import { LMEUserDockOperations } from "../LMEUserDockOperations";
import { Button, DataHeader, DataSource, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDockUser extends Layout {
    buttonSetWebPassword: Button;
    dataheaderDockUser: DataHeader;
    layoutLMEUserDockOperations: LMEUserDockOperations;
    layoutUserGeneral: Layout;
    layoutUserLogin: Layout;
    panelAdminButtons: Panel;
    sourceUserSettings: DataSource;
    tabDock: Tab;
    tabGeneral: Tab;
    tabLogin: Tab;
    tabsetUsers: Tabset;
}
